var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "select2-container--default" }, [
    _c(
      "ul",
      {
        staticClass:
          "select2-selection--multiple flex-start-center flex-wrap py-20",
      },
      [
        _vm._l(_vm.product.allergens, function (a) {
          return _c(
            "li",
            {
              key: "a" + a.id,
              staticClass:
                "fsize-12 radius-20 py-5 px-10 mr-5 mb-10 bg-none color-ko border-ko",
            },
            [_vm._v("\n            " + _vm._s(a.name) + "\n        ")]
          )
        }),
        _vm._v(" "),
        _vm._l(_vm.product.consumables, function (b) {
          return _c(
            "li",
            {
              key: "b" + b.id,
              staticClass:
                "fsize-12 radius-20 py-5 px-10 mr-5 mb-10 bg-none color-ko border-ko",
            },
            [_vm._v("\n            " + _vm._s(b.name) + "\n        ")]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }